import { Store, StoreForm, StoreUpsert } from "@core/models";
import { isValidIanaTimeZone } from "./general.helper";

export function transformToData(store: Store): Store {
  const timeZone = store?.ubicacion?.zonaHoraria ?? '';

  return {
    isArgentina: isValidIanaTimeZone(timeZone),
    ...store,
  }
}

export function transformToForm(store: Store): StoreForm {
  return {} as StoreUpsert;
}

export function transformToUpsert(storeForm: StoreForm): StoreUpsert {
  return {} as StoreUpsert;
}




